// DS3.4
import React from 'react';
import TextInput, { type TextInputProps } from '../TextInput';
import SearchIcon from '../../../Icons/24x24/Search';
import SearchIconSmall from '../../../Icons/16x16/Search';
import CloseIcon from '../../../Icons/24x24/Close';
import CloseIconSmall from '../../../Icons/16x16/Close';
import PlainButtonOrLink from '../../../Buttons/PlainButtonOrLink';
import { IconSize } from '../../../Icons/IconWrap';
import cn from 'classnames';

import s from './SearchInput.scss';

export interface Props extends TextInputProps {
  /** Callback for the clear button click event */
  onClearClick: (e: React.MouseEvent<HTMLElement>) => void;
  /** Size of the search input - 'small' or 'medium' */
  inputSize?: 'small' | 'medium';
}

const SearchInput = React.forwardRef<HTMLInputElement, Props>(
  ({ onClearClick, value, disabled, inputSize = 'medium', className, ...rest }, ref) => {
    const isSmall = inputSize === 'small';

    const prefix = isSmall ? (
      <SearchIconSmall size={IconSize.SMALLER} disableDefaultColors />
    ) : (
      <SearchIcon disableDefaultColors />
    );

    const postfix = value ? (
      <PlainButtonOrLink onClick={onClearClick} type="button">
        {/* todo: need some visually hidden here */}
        {isSmall ? <CloseIconSmall size={IconSize.SMALLER} /> : <CloseIcon />}
      </PlainButtonOrLink>
    ) : null;

    return (
      <TextInput
        ref={ref}
        prefix={prefix}
        postfix={postfix}
        value={value}
        disabled={disabled}
        className={cn(isSmall ? s['small'] : undefined, className)}
        inputClassname={s['input']}
        {...rest}
      />
    );
  }
);

export default SearchInput;
